import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { setEndQuestionary, setEndQuestionaryFailure, setEndQuestionaryIdle, setEndQuestionarySuccess } from '../actions';

const set_end_questionary_status = handleActions(
  {
    [setEndQuestionary.toString()]: (state, action) => 'LOADING',
    [setEndQuestionarySuccess.toString()]: (state, action) => 'SUCCESS',
    [setEndQuestionaryFailure.toString()]: (state, action) => 'FAILURE',
    [setEndQuestionaryIdle.toString()]: (state, action) => 'IDLE',
  },
  'IDLE'
);

const set_end_questionary_data = handleActions(
  {
    [setEndQuestionary.toString()]: () => null,
    [setEndQuestionarySuccess.toString()]: (state, action) => action.payload,
    
  },
  null
);

export { set_end_questionary_status, set_end_questionary_data };
